import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/validation`;

export const validationService = {
  run: async (fileId, options = {}) => {
    const response = await axios.post(`${API_BASE}/run`, {
      file_id: fileId,
      mapping_template_id: options.mapping_template_id,
      user_id: options.user_id,
      validators: options.validators
    });
    return response.data;
  },

  listSessions: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.file_id) params.append('file_id', filters.file_id);
    if (filters.overall_status) params.append('overall_status', filters.overall_status);
    if (filters.source_system_id) params.append('source_system_id', filters.source_system_id);
    if (filters.file_type) params.append('file_type', filters.file_type);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/sessions?${params}`);
    return response.data;
  },

  getSession: async (id) => {
    const response = await axios.get(`${API_BASE}/sessions/${id}`);
    return response.data;
  },

  getFindings: async (sessionId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.severity) params.append('severity', filters.severity);
    if (filters.validator_type) params.append('validator_type', filters.validator_type);
    if (filters.resolved !== undefined) params.append('resolved', filters.resolved);
    if (filters.auto_fixable !== undefined) params.append('auto_fixable', filters.auto_fixable);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/sessions/${sessionId}/findings?${params}`);
    return response.data;
  },

  reviewSession: async (sessionId, decision, userId, notes) => {
    const response = await axios.post(`${API_BASE}/sessions/${sessionId}/review`, {
      decision, user_id: userId, notes
    });
    return response.data;
  },

  resolveFinding: async (findingId, userId, notes) => {
    const response = await axios.put(`${API_BASE}/findings/${findingId}/resolve`, {
      user_id: userId, notes
    });
    return response.data;
  },

  resolveAutoFixable: async (sessionId, userId) => {
    const response = await axios.post(`${API_BASE}/sessions/${sessionId}/auto-fix`, {
      user_id: userId
    });
    return response.data;
  },

  submitToDve: async (sessionId, dveSessionId) => {
    const response = await axios.post(`${API_BASE}/sessions/${sessionId}/submit-to-dve`, {
      dve_verification_session_id: dveSessionId
    });
    return response.data;
  },

  getStatistics: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source_system_id) params.append('source_system_id', filters.source_system_id);
    if (filters.file_id) params.append('file_id', filters.file_id);
    const response = await axios.get(`${API_BASE}/statistics?${params}`);
    return response.data;
  }
};

export default validationService;
